import type { SourceChannel } from './types';

const SEARCH = /google|bing|baidu|sogou|so\.com|360\.|yahoo|duckduckgo|yandex|sm\.cn|shenma/;
const SOCIAL =
  /weibo\.|weixin\.|zhihu\.|twitter\.|facebook\.|instagram\.|tiktok\.|douyin\.|xiaohongshu\.|x\.com|linkedin\.|reddit\.|bilibili\.|qzone\.qq|mp\.weixin/;

function bareHost(value: string): string {
  return value.toLowerCase().replace(/^www\./, '');
}

export function classifySource(referrer: string, pageUrl = ''): SourceChannel {
  if (!referrer) return '直接访问';
  let host = referrer.toLowerCase();
  try {
    host = new URL(referrer).hostname.toLowerCase();
  } catch {
    /* keep raw */
  }
  if (pageUrl) {
    try {
      const pageHost = bareHost(new URL(pageUrl, 'https://example.com').hostname);
      const refHost = bareHost(host);
      if (pageHost && refHost && (refHost === pageHost || refHost.endsWith(`.${pageHost}`) || pageHost.endsWith(`.${refHost}`))) {
        return '直接访问';
      }
    } catch {
      /* keep classifying */
    }
  }
  if (SEARCH.test(host)) return '搜索引擎';
  if (SOCIAL.test(host)) return '社交媒体';
  return '外部链接';
}

export function sourceColor(name: SourceChannel): string {
  if (name === '直接访问') return 'bg-primary-500';
  if (name === '搜索引擎') return 'bg-accent-500';
  if (name === '社交媒体') return 'bg-secondary-500';
  return 'bg-foreground-300';
}

export function sourceHex(name: SourceChannel): string {
  if (name === '直接访问') return '#E25A3C';
  if (name === '搜索引擎') return '#2F9D6A';
  if (name === '社交媒体') return '#C4A484';
  return '#9A8B7A';
}

export function normalizeVisitUrl(url: string): string {
  if (!url) return '/';
  try {
    const u = new URL(url, 'https://example.com');
    const path = (u.pathname || '/') + (u.search || '');
    if (/^https?:\/\//i.test(url) && u.hostname && u.hostname !== 'example.com') {
      return `${u.protocol}//${u.hostname}${path}`;
    }
    return path;
  } catch {
    return url.startsWith('/') ? url : `/${url}`;
  }
}

export function visitPagePath(url: string): string {
  try {
    if (/^https?:\/\//i.test(url)) {
      const u = new URL(url);
      return (u.pathname || '/') + (u.search || '');
    }
  } catch {
    /* keep raw */
  }
  return url || '/';
}

export function visitPageHost(url: string, fallback = ''): string {
  try {
    if (/^https?:\/\//i.test(url)) {
      return new URL(url).hostname.replace(/^www\./, '');
    }
  } catch {
    /* keep fallback */
  }
  return fallback;
}

export function normalizePagePath(url: string): string {
  return visitPagePath(normalizeVisitUrl(url));
}
